import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LocationOn } from '@mui/icons-material';

const StoreDistance = ({ distanceToUserInMiles }) => {
  const { t } = useTranslation();

  if (distanceToUserInMiles === null) return null;

  return (
    <Box display="flex" whiteSpace="nowrap" marginLeft="1rem">
      <LocationOn />
      <Typography>
        {distanceToUserInMiles} {t('locations.card.miles')}
      </Typography>
    </Box>
  );
};

export default StoreDistance;
